import {IndustryRegularIcon} from 'shells/icon/svg/industry-regular-icon';
import {DropdownSelectInline} from 'shells/select-inline/dropdown-select-inline';

import {useGetIndustries} from '../../../core/select/hooks/use-get-industries';

import {appHistory} from '../../../../history';

import {EditFieldWrapper} from '../../shared/header/edit-fields/edit-field-wrapper';

interface Props {
    industryId: string | null | undefined;
    onUpdateAccountIndustry: (industryId: string | null, industryName: string | null) => void;
    canAccessSetup: boolean;
}

export function AccountIndustryField(props: Props) {
    const {industries} = useGetIndustries();

    const selectedIndustry = props.industryId
        ? industries.find((industry) => industry.id === props.industryId)
        : undefined;

    return (
        <EditFieldWrapper
            icon={IndustryRegularIcon}
            label='Industry'
            children={
                <DropdownSelectInline
                    options={industries}
                    selectedValue={selectedIndustry}
                    onChange={(selected) => {
                        props.onUpdateAccountIndustry(
                            selected ? selected.id : null,
                            selected ? selected.name : null
                        );
                    }}
                    onClear={() => {
                        props.onUpdateAccountIndustry(null, null);
                    }}
                    footerButton={
                        props.canAccessSetup && {
                            label: 'Manage industries',
                            onClick: () => {
                                appHistory.push('/setup/industry');
                            },
                        }
                    }
                />
            }
        />
    );
}
